module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "main-width"
  }, [_c('div', [_c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('label', {
    staticStyle: {
      "margin-left": "15px"
    }
  }, [_vm._v("品牌名称：")]), _vm._v(" "), _c('span', [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请输入品牌名称"
    },
    model: {
      value: (_vm.brandName),
      callback: function($$v) {
        _vm.brandName = $$v
      },
      expression: "brandName"
    }
  })], 1), _vm._v(" "), _c('label', {
    staticStyle: {
      "margin-left": "25px"
    }
  }, [_vm._v("商品名称：")]), _vm._v(" "), _c('span', [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请输入商品名称"
    },
    model: {
      value: (_vm.goodsName),
      callback: function($$v) {
        _vm.goodsName = $$v
      },
      expression: "goodsName"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "shelves-filter-btn-default shelves-filter",
    staticStyle: {
      "margin-left": "25px"
    },
    on: {
      "click": _vm.init
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('span', {
    staticClass: "shelves-filter-btn-default shelves-cancel",
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("重置")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "30px 0 10px",
      "font-size": "12px",
      "color": "#bca365"
    }
  }, [_c('div', [_c('span', {
    staticStyle: {
      "width": "10px",
      "display": "inline-block"
    }
  }), _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "将勾选的商品批量加入报价表",
      "placement": "top",
      "popper-class": "custom-width"
    }
  }, [_c('el-button', {
    staticStyle: {
      "background-color": "#ffa726",
      "border-color": "#ffa726"
    },
    attrs: {
      "type": "danger",
      "size": "small"
    },
    on: {
      "click": _vm.getPriceAll
    }
  }, [_vm._v("批量加入报价表")])], 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "width": "10px",
      "display": "inline-block"
    }
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "background-color": "#ffa726",
      "border-color": "#ffa726"
    },
    attrs: {
      "type": "danger",
      "size": "small"
    },
    on: {
      "click": _vm.addNewShelvesAll
    }
  }, [_vm._v("批量加入货架")]), _vm._v(" "), _c('div', {
    staticClass: "get-price-label",
    staticStyle: {
      "line-height": "30px",
      "display": "inline-block",
      "margin": "0",
      "height": "30px",
      "padding": "0 10px",
      "margin-left": "20px"
    },
    on: {
      "click": _vm.deleteGoodsMore
    }
  }, [_vm._v("\n            批量移除商品\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "get-price-label",
    staticStyle: {
      "line-height": "30px",
      "display": "inline-block",
      "margin": "0",
      "height": "30px",
      "padding": "0 10px",
      "margin-left": "20px",
      "border": "none"
    },
    on: {
      "click": _vm.oneKeyDeleteGoodsMore
    }
  }, [_vm._v("\n            一键清除失效商品\n          ")])], 1)]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasGoods),
      expression: "hasGoods"
    }],
    staticClass: "table-static th-eee",
    class: _vm.fixedBool == true ? 'table-fixed' : '',
    attrs: {
      "data": _vm.tableData,
      "tooltip-effect": "dark",
      "fit": "",
      "id": "table-scroll"
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "label": "全选",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "商品信息",
      "align": "center",
      "width": "400"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.goodsVo) ? [_c('div', {
          staticClass: "goods-info"
        }, [_c('div', {
          staticClass: "goods-img-box"
        }, [_c('router-link', {
          attrs: {
            "tag": "a",
            "target": "_blank",
            "to": {
              name: 'Detail',
              query: {
                goodsId: scope.row.goodsVo.goodsId
              },
            }
          }
        }, [_c('div', {
          staticClass: "goods-img"
        }, [_c('img', {
          attrs: {
            "src": scope.row.goodsVo.goodsPicture
          },
          on: {
            "error": function($event) {
              return _vm.error(1)
            }
          }
        }), _vm._v(" "), _c('div', {
          staticClass: "category-cover-image",
          class: {
            a: scope.row.goodsVo.hasTax == 1
          }
        })])]), _vm._v(" "), _c('div', {
          staticClass: "delete-btn",
          on: {
            "click": function($event) {
              return _vm.deleteGoods(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-delete"
        })])], 1), _vm._v(" "), _c('div', {
          staticStyle: {
            "margin-left": "15px",
            "text-align": "left"
          }
        }, [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": scope.row.goodsVo.goodsName,
            "placement": "top"
          }
        }, [_c('div', {
          staticStyle: {
            "font-size": "14px",
            "text-align": "left",
            "color": "#333",
            "display": "-webkit-box",
            "-webkit-box-orient": "vertical",
            "-webkit-line-clamp": "2",
            "overflow": "hidden"
          }
        }, [_vm._v("\n                    " + _vm._s(scope.row.goodsVo.goodsName) + "\n                  ")])]), _vm._v(" "), _c('div', {
          staticStyle: {
            "font-size": "14px",
            "margin": "5px 0",
            "text-align": "left",
            "color": "#666"
          }
        }, [_vm._v("\n                  品牌：" + _vm._s(scope.row.goodsVo.brandName) + "\n                ")]), _vm._v(" "), (scope.row.goodsVo.appType == 2) ? _c('div', {
          staticClass: "type-icon",
          staticStyle: {
            "display": "inline-block",
            "line-height": "22px",
            "text-align": "center"
          }
        }, [_vm._v("\n                  社群集采\n                ")]) : _vm._e(), _vm._v(" "), (scope.row.goodsVo.appType == 1) ? _c('div', {
          staticClass: "type-icon",
          staticStyle: {
            "display": "inline-block",
            "line-height": "22px",
            "text-align": "center"
          }
        }, [_vm._v("\n                  一件代发\n                ")]) : _vm._e(), _vm._v(" "), (scope.row.goodsVo.isSelf == 1) ? _c('div', {
          staticClass: "type-icon",
          staticStyle: {
            "background-color": "rgb(231, 249, 235)",
            "color": "rgb(88, 191, 106)",
            "margin-top": "10px",
            "display": "inline-block",
            "line-height": "22px",
            "text-align": "center"
          }
        }, [_vm._v("\n                  自产自销\n                ")]) : _vm._e()], 1)])] : [_c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("商品失效了")])]]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "标签",
      "align": "center",
      "width": "250"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.goodsVo) ? _vm._l((scope.row.goodsVo.labelNames), function(item, index) {
          return _c('span', {
            key: index,
            staticClass: "table-label-tip"
          }, [_vm._v(_vm._s(item))])
        }) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "建议零售价",
      "align": "center",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.goodsVo) ? [_vm._v("\n            ￥" + _vm._s(scope.row.goodsVo.suggestSalePrice / 100) + "\n            ")] : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "结算价（+运费）",
      "align": "center",
      "width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.goodsVo) ? [_c('div', {
          staticStyle: {
            "color": "#ffa726"
          }
        }, [_vm._v("\n              ￥" + _vm._s(scope.row.goodsVo.lowCooperatePrice / 100) + "（+" + _vm._s(scope.row.goodsVo.fright / 100) + "）\n            ")])] : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "毛利",
      "align": "center",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.goodsVo) ? [_vm._v("\n            ￥" + _vm._s(scope.row.goodsVo.profitValue / 100) + "\n            ")] : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "毛利率",
      "align": "center",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.goodsVo) ? [_vm._v("\n            " + _vm._s(scope.row.goodsVo.profitMargin) + "%\n            ")] : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "操作",
      "align": "center",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.goodsVo) ? [(scope.row.goodsVo.shelvesStatus == 0) ? _c('div', {
          staticClass: "category-goods-add-default",
          staticStyle: {
            "margin-top": "0",
            "height": "40px",
            "background-color": "#ffa726",
            "border-color": "#ffa726",
            "color": "#fff"
          },
          on: {
            "click": function($event) {
              return _vm.addNewShelves(scope.row)
            }
          }
        }, [_vm._v("\n                加入货架\n              ")]) : _vm._e(), _vm._v(" "), (scope.row.goodsVo.shelvesStatus == 1) ? _c('div', {
          staticClass: "category-goods-add-default yishangjia",
          staticStyle: {
            "margin-top": "0",
            "height": "40px"
          }
        }, [_vm._v("\n                已加入货架\n              ")]) : _vm._e(), _vm._v(" "), (true) ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "添加商品报价至报价篮子，可以批量导出商品报价",
            "placement": "top",
            "popper-class": "custom-width"
          }
        }, [_c('div', {
          staticClass: "get-price-label",
          staticStyle: {
            "background-color": "#ffa726",
            "border-color": "#ffa726",
            "color": "#fff"
          },
          on: {
            "click": function($event) {
              return _vm.getPrice(scope.row)
            }
          }
        }, [_vm._v("\n                  加入报价表\n                ")])]) : _vm._e()] : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasGoods),
      expression: "hasGoods"
    }],
    staticClass: "block"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "total, sizes, prev, pager, next",
      "page-sizes": [30, 60, 100],
      "current-page": _vm.pageNum,
      "total": _vm.pageTotal,
      "page-size": _vm.pageSize
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        _vm.pageNum = $event
      },
      "update:current-page": function($event) {
        _vm.pageNum = $event
      }
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.hasGoods),
      expression: "!hasGoods"
    }],
    staticClass: "category-goods-wrap-no"
  }, [_c('div', {
    staticClass: "category-goods-wrap-tip"
  }, [_vm._v("没有找到相关商品...")])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "",
      "visible": _vm.dialogVisible2,
      "width": "600px",
      "before-close": _vm.handleClose2
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible2 = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("\n      成功添加商品到“报价表”，可以前往“报价表”批量导出商品报价！\n    ")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "category-goods-add-default",
    staticStyle: {
      "width": "200px",
      "margin": "0 auto"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible2 = false
      }
    }
  }, [_vm._v("\n        我知道了\n      ")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ec7c3f3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PriceLibraryGoods.vue
// module id = 531
// module chunks = 1